import axiosInstance from "../helpers/axios/axiosInstance";
import { server_url } from "../constants/constants";

export async function getPrescription() {
  try {
    const response = await axiosInstance.get(server_url + "/prescription");
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: error.response.data.message };
  }
}

export async function getPrescriptionByPatient(patientid) {
  try {
    const response = await axiosInstance.get(
      server_url + "/prescription/getPrescription/" + patientid
    );
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: error.response.data.message };
  }
}

export async function addPrescription(prescriptionData) {
  try {
    const response = await axiosInstance.post(
      server_url + "/prescription",
      prescriptionData
    );
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: error.response.data.message };
  }
}

export async function deletePrescription(id) {
  try {
    const response = await axiosInstance.delete(
      server_url + "/prescription/" + id
    );
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: error.response.data.message };
  }
}

export async function addPrescriptionById(prescriptionData) {
  try {
    const response = await axiosInstance.post(
      server_url + "/prescription/addPrescription",
      prescriptionData
    );
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: error.response.data.message };
  }
}

export async function getPrescriptionslatest(id, latest) {
  if (latest) {
    try {
      const response = await axiosInstance.get(
        `${server_url}/prescription/getPrescriptions?latest=${true}&patient_id=${id}`,
      );
      if (response.success) return { success: true };
      else return { success: false };
    } catch (error) {
      alert("Error fetching prescription status" + id);
      return { success: false };
    }
  } else {
    try {
      const response = await axiosInstance.get(
        `${server_url}/prescription/getPrescriptions?patient_id=${id}`,
      );
      if (response.success) return { success: true };
      else {
        return { success: false };
      }
    } catch (error) {
      alert("Error fetching prescription status" + id);
      return { success: false };
    }
  }
}

export async function getPrescriptionslatestbyappt(appointmentId) {
  if (!appointmentId) {
    return { success: false, data: "Invalid appointment ID" };
  }

  try {
    const response = await axiosInstance.get(
      `${server_url}/prescription/getPrescriptionById?appointment_id=${appointmentId}`,
    );
    console.log(JSON.stringify(response));
    // alert("done fetching prescription status" + appointmentId);
    return response.data;
  } catch (error) {
    // alert("Error fetching prescription status" + appointmentId);
    console.log(error);
    return { success: false };
  }
}
